/** Converte respostas FastAPI em mensagens legíveis para a UI. */
function parseApiError(response, data, fallback) {
  if (response?.status === 401) {
    return "Sessão expirada ou token inválido. Saia e faça login novamente.";
  }
  if (response?.status === 403) {
    return typeof data?.detail === "string" ? data.detail : "Permissão insuficiente.";
  }
  if (typeof data?.detail === "string") {
    return data.detail;
  }
  if (Array.isArray(data?.detail)) {
    return data.detail.map((item) => item.msg || JSON.stringify(item)).join(" | ");
  }
  if (data?.detail) {
    return JSON.stringify(data.detail);
  }
  return fallback;
}

/** Mapeia erros 422 do Pydantic para campos do formulário. */
function parseFieldErrors(data) {
  if (!Array.isArray(data?.detail)) return {};
  const out = {};
  data.detail.forEach((item) => {
    const loc = item.loc || [];
    const key = loc[loc.length - 1];
    if (key && typeof key === "string") {
      out[key] = item.msg || "Valor inválido";
    }
  });
  return out;
}

export { parseApiError, parseFieldErrors };
